import { CcmStatuses, RpmStatuses } from 'infrastructure/enums';
import useUser from 'utils/useUser';

import { usePatientInfo } from './use-patient-info';

interface Props {
  patientGuid: string;
}

export const TRACKING_PLATFORM_OPTIONS = [
  { label: 'RPM', value: 'RPM' },
  { label: 'CCM', value: 'CCM' },
];

export const useTrackingPlatform = ({ patientGuid }: Props) => {
  const { patientInfo } = usePatientInfo({ patientGuid });
  const { isPractice } = useUser();

  const isActiveOrPendingReview =
    patientInfo?.status === RpmStatuses.Active ||
    patientInfo?.status === RpmStatuses.PendingReview ||
    patientInfo?.status === RpmStatuses.Onboarding;
  const isCcmEnrolled =
    patientInfo?.ccmStatus === CcmStatuses.Enrolled ||
    patientInfo?.ccmStatus === CcmStatuses.CCMOnboarding;

  const showTrackingPlatform =
    isActiveOrPendingReview && isCcmEnrolled && !isPractice;

  const getTrackingPlatform = (formValue?: string | null) => {
    if (showTrackingPlatform) return formValue;
    if (isPractice) return 'CCM';
    if (isActiveOrPendingReview && !isCcmEnrolled) return 'RPM';
    if (!isActiveOrPendingReview && isCcmEnrolled) return 'CCM';
    return undefined;
  };

  return { showTrackingPlatform, getTrackingPlatform };
};
